import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import type { IIntegrationUISettingsSection } from '@feathr/components';

import RaisersEdgeTabContent from '../RaisersEdgeTabContent';
import RaisersEdgeConnectionDetails from './RaisersEdgeConnectionDetails';
import RaisersEdgeUnsubscribeSettings from './RaisersEdgeUnsubscribeSettings';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
  /** The config's settings sections. */
  sections: readonly IIntegrationUISettingsSection[];
  /** Disables every setting with this reason, e.g. while the page saves. */
  disabledReason?: string;
}

function RaisersEdgeSettingsTab({
  disabledReason,
  integration,
  sections,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <RaisersEdgeTabContent
      inactiveLabel={t('Connect Blackbaud to see the connection details and manage unsubscribes.')}
      integration={integration}
    >
      <RaisersEdgeConnectionDetails integration={integration} />
      <RaisersEdgeUnsubscribeSettings
        disabledReason={disabledReason}
        integration={integration}
        sections={sections}
      />
    </RaisersEdgeTabContent>
  );
}

export default RaisersEdgeSettingsTab;
